import { AbstractCanvasDecorator, CanvasCoordinates } from '@damofire/uix-commons';
import { Description, EmbeddedAsset, LocalizedRiskLevel } from '@damofire/data-watson';

export interface CanvasIssueComponent {
  asset?: EmbeddedAsset;
  component?: Description<number>;
  equipment?: number;
  riskLevel?: LocalizedRiskLevel;
  depth?: number;
  coordinates?: {
    x?: number;
    y?: number;
    sideView?: boolean;
  };
}

export class WatsonCanvasDecorator extends AbstractCanvasDecorator {
  issuePriorityConfigs: LocalizedRiskLevel[] = [];
  protected renderComponents(): void {
    //
  }
  searchPossibleTargets(eventCoordinates: CanvasCoordinates): any {
    //
  }
  selectTarget(target: any, coordinates: CanvasCoordinates): void {
    //
  }
  zoomToTarget(): void {
    //
  }
  setPriorityConfigs(issuePriorityConfigs: LocalizedRiskLevel[]): void {
    this.issuePriorityConfigs = issuePriorityConfigs;
    this.renderAll();
  }
}
